<template>
  <div>
    <h2 class="widget-title text-capitalize">通知公告</h2>
    <div class="latest-news-posts">
      <div class="latest-news-area" v-for="item in news" :key="item.Id">
        <div class="date-meta-text">
          <i class="fas fa-calendar-alt"></i>{{item.PublishTime}}
        </div>
        <h3 class="latest-title bold-font">
          <a v-if="item.Url" :href="item.Url" target="_blank">{{item.Title}}</a>
          <a v-if="!item.Url" @click="goNewDetails(item.Id)">{{item.Title}}</a>
        </h3>
      </div>
    </div>
  </div>
</template>
<script>

import { ProjectSettings } from '../../base/base.js';

export default {
  data() {
    return {
      news: [],
      NewHomePage: ProjectSettings.NewHomePage
    }
  },
  mounted() {
    this.$store.dispatch('getNews', { newsCategoryId: 1, length: 4 }).then(res => {
      if (res.Data.length > 3 && this.NewHomePage === true) {
        this.news = res.Data.slice(0, 3);
      } else {
        this.news = res.Data;
      }
    });
  },
  methods: {
    goNewDetails(id) {
      let routeUrl = this.$router.resolve({
        path: 'notice',
        query: {
          Id: id
        }
      });
      window.open(routeUrl.href, '_blank');
    }
  }
}
</script>

<style lang="scss" scoped>
.widget-title {
  font-size: 30px;
  font-weight: 500;
}
.date-meta-text {
  i {
    margin-right: 10px;
    color: #989898 !important;
    font-size: 14px;
  }

  color: #989898 !important;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 6px;
}

.fa-calendar-alt {
  margin-right: 10px;
}

.latest-title {
  margin-bottom: 0;
  a:hover {
    cursor: pointer;
  }
}
.latest-news-area {
  display: inline-block;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ccc;
  width: 100%;
  max-width: 335px;
}
.latest-news-area:last-child {
  border-bottom: none;
  padding-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/home/new/index_list.vue